import type {
  DateFilterModel,
  ICombinedSimpleModel,
  IMultiFilterModel,
  ISimpleFilterModel,
  NumberFilterModel,
  SetFilterModel,
  TextFilterModel,
} from 'ag-grid-community';

export const isMultiFilter = (val: any): val is IMultiFilterModel => {
  return (val as IMultiFilterModel)?.filterType === 'multi' && 'filterModels' in val;
};

export const isNumberFilter = (val: any): val is NumberFilterModel => {
  return (val as NumberFilterModel)?.filterType === 'number';
};
export const isTextFilter = (val: any): val is TextFilterModel => {
  return (val as TextFilterModel)?.filterType === 'text';
};
export const isSetFilter = (val: any): val is SetFilterModel => {
  return (val as SetFilterModel)?.filterType === 'set';
};
export const isDateFilter = (val: any): val is DateFilterModel => {
  return (val as DateFilterModel)?.filterType === 'date';
};

export function isSimpleFilter(val: any) {
  return isNumberFilter(val) || isTextFilter(val) || isSetFilter(val) || isDateFilter(val);
}

export const isCombinedSimpleModel = <TModel extends ISimpleFilterModel>(
  val: any,
): val is ICombinedSimpleModel<TModel> => {
  return (val as ICombinedSimpleModel<TModel>)?.operator !== undefined;
};
